import { useState, useEffect } from 'react';
import { supabase } from './supabase';
import HomePage from './HomePage';
import Auth from './Auth';
import Dashboard from './Dashboard';

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [screen, setScreen] = useState('home');

  const isPortfolioSubdomain = window.location.hostname.startsWith('portfolio.');

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' }}>
        <div style={{ fontSize: 28, fontWeight: 800, background: 'linear-gradient(135deg, #3B82F6, #14B8A6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Folio</div>
      </div>
    );
  }

  // Logged in → dashboard
  if (session) return <Dashboard session={session} />;

  // Portfolio subdomain → skip homepage, go straight to login
  if (isPortfolioSubdomain) {
    return <Auth defaultMode="signin" onBack={null} />;
  }

  // Main domain → show homepage
  if (screen === 'home') {
    return <HomePage onSignIn={() => setScreen('signin')} onSignUp={() => setScreen('signup')} />;
  }

  return <Auth defaultMode={screen === 'signup' ? 'signup' : 'signin'} onBack={() => setScreen('home')} />;
}